import { withAsyncScript } from '../../components/AsyncScriptWrapper/AsyncScriptWrapper.react';

import GoogleMap from '../../components/GoogleMap';

/**
 * Google Map container component.
 * Wrapped with async script so Google Map is always ready.
 */

// Configuration of async script requirement
const asyncScriptProps = {
  // ID given to script tag in index
  id: 'gmaps',
  // Global variable name when ready
  global: 'google',
  // Name to deliver global as prop (ensure loaded scope)
  propName: 'googleAPI',
};

// Wrap with async script loader, which adds global object as prop when ready
const MapWithAsync = withAsyncScript(GoogleMap, asyncScriptProps);

export default MapWithAsync;



// WEBPACK FOOTER //
// ./app/src/containers/GoogleMap/index.jsx